import type { components } from '@fluencelabs/vodopad-admin-api'
import { useList } from '@refinedev/core'
import { useMemo } from 'react'

import { useUserActions } from '../hooks/useUserActions'
import { SetPropertyModal } from './SetPropertyModal'

type BasicUserGroupDto = components['schemas']['BasicUserGroupDto']

interface Props {
  open: boolean
  userIds: string[]
  userEmail?: string
  currentGroup?: string
  onClose: () => void
}

export function SetGroupModal({
  open,
  userIds,
  userEmail,
  currentGroup,
  onClose,
}: Props) {
  const { setGroup } = useUserActions()

  const groupsResult = useList<BasicUserGroupDto>({
    resource: 'user-groups',
    pagination: { pageSize: 100 },
    queryOptions: { enabled: open },
  })

  const options = useMemo(
    () =>
      (groupsResult.query.data?.data ?? []).map((g) => ({
        label: g.name,
        value: g.name,
      })),
    [groupsResult.query.data?.data],
  )

  return (
    <SetPropertyModal
      open={open}
      title="Set Group"
      label="Group"
      fieldName="groupName"
      userIds={userIds}
      userEmail={userEmail}
      currentValue={currentGroup}
      options={options}
      showSearch
      onSubmit={(value, ids) => setGroup(value, ids)}
      onClose={onClose}
    />
  )
}
